import {registerJQueryComponent} from '@lib/JQueryRegistry'

export default class Notification {

    /**
     * Constructs a new {@link Notification}.
     * @param {HTMLElement} rootElement
     */
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            closeButton: rootElement.find('.w-notification-close')
        }

        this.$props = {
            timeout: Number.parseInt(this.$dom.root.data('timeout'))
        }

        this.$dom.closeButton.click(this.handleCloseButtonClick);

        if (this.$props.timeout > 0) {
            setTimeout(() => {
                this.hideNotification()
            }, this.$props.timeout * 1000)
        }
    }

    handleCloseButtonClick = () => {
        this.hideNotification();
    }

    hideNotification() {
        this.$dom.root.fadeOut(150)
    }
}

registerJQueryComponent(Notification, '.w-notification')